import { render, staticRenderFns } from "./WxNotOpenPage.vue?vue&type=template&id=cf970770&scoped=true&"
import script from "./WxNotOpenPage.vue?vue&type=script&lang=js&"
export * from "./WxNotOpenPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf970770",
  null
  
)

export default component.exports